/* eslint-disable no-unused-vars */
import {
    Accordion,
    AccordionItem,
    BoxedRow,
    Divider,
    IconDataBonusRegular,
    Row,
    Text1,
    Text2,
    Text6,
    skinVars,
} from '@telefonica/mistica';
import React, { useEffect, useMemo, useState } from 'react';
import './index.scss';
import { formatPrices, conversionToGB, formatTimeConsumption } from '../../utils/dataTransformation/unitsConversion';
import { useTranslation } from 'react-i18next';
import '../../translations/i18n';
import { useNavigate } from 'react-router-dom';
import navigateParams from '../../utils/navigation/navigateParams';
import SharedData from '../../pages/home/details/sharedData';

export interface DetailConsumptionCardData {
    sharedData: boolean;
    dataDetail: any;
    activeView: any;
    isMobile: boolean;
    setError: (ev: string) => void;
}

export const DetailConsumptionCard: React.FC<DetailConsumptionCardData> = ({
    sharedData,
    dataDetail,
    activeView,
    isMobile,
    setError,
}: DetailConsumptionCardData) => {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const [windowWidth, setWindowWidth] = useState<any>(window.innerWidth);
    let current = 0;
    let max: any = 0;
    let extraSumData: any;
    let extraSumVoice: any;
    let extraSumSMS: any;
    let extraSumOthers: any;
    let extraSumOnlyCalls: any;
    let unit: any;

    if (dataDetail.data) {
        const isDataSharing = dataDetail.datasharing ? 'dataSharing' : 'data';
        unit = dataDetail[isDataSharing]?.unit;
        current = dataDetail[isDataSharing]?.current;
        max = dataDetail[isDataSharing]?.max;
        extraSumData = dataDetail[isDataSharing]?.extra;
        extraSumVoice = dataDetail?.voice?.extra;
        extraSumSMS = dataDetail?.sms?.extra;
        extraSumOthers = '0';
    }

    if (dataDetail) {
        extraSumOnlyCalls = dataDetail.extraSum;
        extraSumOthers = '0';
    }
    const percentage = Math.round((current * 100) / max);
    const colorTextGB = useMemo(() => {
        let aux;
        if (percentage >= 100) {
            aux = skinVars.colors.errorHigh;
        }
        return aux;
    }, [percentage]);

    const sendToNative = () => {
        const type = 'modeFlow-backgroundBlue';
        const title = 'Datos compartidos';
        const url = '/mobile/consumption/shared-data';
        const queryParams = { productPsId: dataDetail.productPsId };
        if (navigateParams(type, url, queryParams, dataDetail, title)) {
            navigate(url + '?productPsId=' + dataDetail.productPsId);
        }
    };
    useEffect(() => {
        const handleResize = () => {
            setWindowWidth(window.innerWidth);
        };

        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    const printTabHeader = () => {
        return (
            <div
                className={
                    activeView !== 'Otros'
                        ? 'DetailConsumptionCard__headline'
                        : 'DetailConsumptionCard__headline__others'
                }
            >
                <div className='DetailConsumptionCard__headline-consumo'>
                    {
                        <>
                            {activeView === 'DATA' && (
                                <>
                                    <Text1 medium color={skinVars.colors.textSecondary}>
                                        {t('consumptionDetailsHeader')}
                                    </Text1>
                                    <div className='DetailConsumptionCard__headline-consumo-data'>
                                        <div className='DetailConsumptionCard__headline-consumo-data-gb'>
                                            <Text6 color={colorTextGB}>{conversionToGB(unit, current, 2)}</Text6>
                                        </div>
                                        <Text2 regular>de {conversionToGB(unit, max, 0)}</Text2>
                                    </div>
                                </>
                            )}
                            {activeView === 'VOICE' && (
                                <>
                                    <Text1 medium color={skinVars.colors.textSecondary}>
                                        {t('consumptionDetailsHeader')}
                                    </Text1>
                                    <div className='DetailConsumptionCard__headline-consumo-data'>
                                        <div className='DetailConsumptionCard__headline-consumo-data-gb'>
                                            <Text6>{formatTimeConsumption(dataDetail.voice.current)}</Text6>
                                        </div>
                                        <Text2 regular>
                                            de{' '}
                                            {dataDetail.voice.max === -1
                                                ? 'ilimitados'
                                                : formatTimeConsumption(dataDetail.voice.max)}
                                        </Text2>
                                    </div>
                                </>
                            )}
                            {activeView === 'SMS' && (
                                <>
                                    <Text1 medium color={skinVars.colors.textSecondary}>
                                        {t('consumptionDetailsHeader')}
                                    </Text1>
                                    <div className='DetailConsumptionCard__headline-consumo-data'>
                                        <div className='DetailConsumptionCard__headline-consumo-data-gb'>
                                            <Text6>{dataDetail.sms.current} SMS</Text6>
                                        </div>
                                        <Text2 regular>
                                            de{' '}
                                            {dataDetail.sms.max === -1
                                                ? 'ilimitados'
                                                : formatTimeConsumption(dataDetail.sms.max)}
                                        </Text2>
                                    </div>
                                </>
                            )}
                            {activeView === 'DATA' && dataDetail.dataBonus && (
                                <div className='DetailConsumptionCard__headline-bono'>
                                    <div className='DetailConsumptionCard__headline-bono-icon'>
                                        <IconDataBonusRegular size={16} />
                                    </div>
                                    <Text1 regular color={skinVars.colors.textSecondary}>
                                        {t('extraBonusDetails')}
                                    </Text1>
                                </div>
                            )}
                        </>
                    }
                </div>
                <div className='DetailConsumptionCard__headline-bills'>
                    <Text1 medium color={skinVars.colors.textSecondary}>
                        {t('extraExpenseDetailsHeader')}
                    </Text1>
                    {activeView === 'DATA' && <Text6>{formatPrices(extraSumData, 'spent')}</Text6>}
                    {activeView === 'VOICE' && (
                        <Text6>{formatPrices(isMobile ? extraSumVoice : extraSumOnlyCalls, 'spent')}</Text6>
                    )}
                    {activeView === 'SMS' && <Text6>{formatPrices(extraSumSMS, 'spent')}</Text6>}
                    {activeView === 'Otros' && <Text6>{formatPrices(extraSumOthers, 'spent')}</Text6>}
                </div>
            </div>
        );
    };

    try {
        return (
            <>
                <div className='DetailConsumptionCard'>
                    <BoxedRow
                        headline={printTabHeader()}
                        title={''}
                        extra={
                            activeView === 'DATA' &&
                            sharedData && (
                                <div className='DetailConsumptionCard__extra'>
                                    <div className='DetailConsumptionCard__extra-divider'>
                                        <Divider></Divider>
                                    </div>
                                    {windowWidth >= 1024 ? (
                                        <div className='DetailConsumptionCard__extra-accordeon'>
                                            <Accordion singleOpen={true}>
                                                <AccordionItem
                                                    title={t('sharedDataDetails')}
                                                    content={<SharedData></SharedData>}
                                                />
                                            </Accordion>
                                        </div>
                                    ) : (
                                        sharedData && (
                                            <div className='DetailConsumptionCard__extra-row'>
                                                <Row
                                                    title={'Datos compartidos'}
                                                    onPress={() => {
                                                        sendToNative();
                                                    }}
                                                />
                                            </div>
                                        )
                                    )}
                                </div>
                            )
                        }
                    />
                </div>
            </>
        );
    } catch (error) {
        setError(activeView);
        return <></>;
    }
};

export default DetailConsumptionCard;
